<template>
  <v-list-group :value="searchUserAndCompany">
    <template v-slot:activator>
      <v-list-item-title v-if="isUser">{{ $tc("User", 2) }}</v-list-item-title>
      <v-list-item-title v-else>{{ $tc("Company", 2) }}</v-list-item-title>
    </template>
    <v-list-item
      v-for="(user, index) in filteredAssignees"
      :key="index"
      dense
      style="padding-left: 0px;"
      @click="
        activityMenu
          ? $emit('addCompanyOrUser', user)
          : $emit('addIndividualUser', user)
      "
    >
      <v-list-item-avatar height="25px" width="25px" min-width="25px">
        <v-img :src="user.image" sizes="small" />
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-subtitle
          v-if="isUser"
          v-html="user.first_name + ' ' + user.last_name"
        />
        <v-list-item-subtitle v-else v-html="user.name" />
      </v-list-item-content>
    </v-list-item>
  </v-list-group>
</template>
<script>
export default {
  name: "AssignementMenuListItem",

  props: {
    /**
     * Input for the user to search user or company
     */
    searchUserAndCompany: {
      type: String
    },
    /**
     * receives list of users or companies
     */
    filteredAssignees: {
      type: Array
    },
    /**
     * Tells component if menu was opened in the activity (not in the tasks)
     */
    activityMenu: {
      type: Boolean,
      default: false
    },
    /**
     *Tells component if list is user list or company (false)
     */
    isUser: {
      type: Boolean
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/WorkOrderForm/_Molecules/AssignmentMenuListItem.vue